import React from 'react';
import ReactDOM from 'react-dom';

export default function ConfirmDialog({ open, icon, title, message, confirmLabel, confirmClass = 'btn-primary', onConfirm, onCancel }) {
  if (!open) return null;
  return ReactDOM.createPortal(
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 99999, padding: 16,
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: '28px 28px 24px', width: 360,
        maxWidth: '100%', boxShadow: '0 20px 60px rgba(0,0,0,.2)',
        animation: 'fadeIn .15s ease',
        fontFamily: 'Inter, Segoe UI, sans-serif',
      }}>
        {icon && (
          <div style={{ textAlign: 'center', fontSize: '2.2rem', marginBottom: 12 }}>{icon}</div>
        )}
        <div style={{ fontWeight: 700, fontSize: '1.05rem', color: '#1e293b', marginBottom: 8, textAlign: 'center' }}>
          {title}
        </div>
        <div style={{ fontSize: '0.875rem', color: '#64748b', textAlign: 'center', lineHeight: 1.55, marginBottom: 24 }}>
          {message}
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1, padding: '10px 0', borderRadius: 10, border: '1px solid #e2e8f0',
              background: '#f8fafc', color: '#1e293b', fontWeight: 600, fontSize: '0.875rem', cursor: 'pointer',
              transition: 'background .15s',
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className={`btn ${confirmClass}`}
            style={{ flex: 1, justifyContent: 'center', padding: '10px 0', borderRadius: 10, fontSize: '0.875rem' }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
